
import { defineComponent } from "vue";

export default defineComponent({
props: {
   'message': String ,
   'classes' : String
    }});
